// extracted by mini-css-extract-plugin
export default {"popupview":"popupview_a2cf5a8b0943a4a54137"};